module.exports = __webpack_public_path__ + "img/nozzle_section.asm.d336b941.jpg";